import { createApp, h } from 'vue';
import { Rollbar } from '@/models/rollbar.interface';
import App from '@/presentation/app.vue';
import LogIn from '@/stand-alone/log-in/log-in.vue';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';
import Bootstrapper from '@/bootstrapper';
import StylesheetLoader from '@/stylesheet-loader';

const standAloneLogin = webpackDefinitions.STAND_ALONE_LOGIN === 'true';
const url = webpackDefinitions.VUE_APP_ICONSET_URL;

declare global {
	interface Window {
		Rollbar?: Rollbar;
	}
}

StylesheetLoader.loadStylesheet(url);

store.mutations.setStandAloneLogin(standAloneLogin);
const placeholderSelector = '#DataImportSystemFrontendPlaceholder';

Bootstrapper.bootstrap()
	.then(() => {
		const app = createApp({
			render: () => {
				return h(App);
			}
		});

		rollbarOperator.handleVueErrorsAndWarnings(app);

		app.mount(placeholderSelector);
	})
	.catch((error: Error) => {
		if (!standAloneLogin || error.name !== 'NotAuthorizedException') {
			throw error;
		}

		const app = createApp({
			render: () => {
				return h(LogIn);
			}
		});

		app.mount(placeholderSelector);
	});
